import API from "./API";

export default class EntidadePessoal extends API
{
    static async all(params) {
        return this.get("api/admin/entidades-pessoal/list", {params:params});
    }
}